import React from 'react';
import '../../css/soldier.css';

import Button from '../../../../core/web/js/button/Button';
import AddButton from '../../../../core/web/js/button/Add';
import EditButton from '../../../../core/web/js/button/Edit';
import ResetButton from '../../../../core/web/js/button/Reset';

import TextInput from '../../../../core/web/js/form/TextInput';
import Textarea from '../../../../core/web/js/form/Textarea';
import Select from '../../../../core/web/js/form/Select';
import {change} from '../../../../core/web/js/form/FormUtil';
import ErrorMessage from '../../../../core/web/js/message/Error';
import {closeMessage} from '../../../../core/web/js/message/MessageUtil';

function Soldier(props){
  const soldiertypes = [
    {
      "value":"Standard",
      "label":"Standard"
    },{
      "value":"Specialist",
      "label":"Specialist"
    }
  ];
  return (
    <div className="soldier">
      <div className="content">
        <ErrorMessage message={props.state.errorMessage}
          close={closeMessage.bind(this,props,'errorMessage')}
          duration={5000}
        />
        <div className="form">
          <Select
            label={"Type"}
            value={props.state.types}
            options={soldiertypes}
            change={change.bind(this, props, 'type')}
          />
          <TextInput
            label={"Name"}
            value={props.state.name}
            change={change.bind(this, props, 'name')}
          />
          <TextInput
            label={"Move"}
            value={props.state.move}
            change={change.bind(this, props, 'move')}
            type="number"
          />
          <TextInput
            label={"Fight"}
            value={props.state.fight}
            change={change.bind(this, props, 'fight')}
            type="number"
          />
          <TextInput
            label={"Shoot"}
            value={props.state.shoot}
            change={change.bind(this, props, 'shoot')}
            type="number"
          />
          <TextInput
            label={"Armor"}
            value={props.state.armor}
            change={change.bind(this, props, 'armor')}
            type="number"
          />
          <TextInput
            label={"Will"}
            value={props.state.will}
            change={change.bind(this, props, 'will')}
            type="number"
          />
          <TextInput
            label={"Health"}
            value={props.state.health}
            change={change.bind(this, props, 'health')}
            type="number"
          />
          <TextInput
            label={"Cost"}
            value={props.state.cost}
            change={change.bind(this, props, 'cost')}
            type="number"
          />
          <Textarea
            label={"Notes"}
            value={props.state.notes}
            change={change.bind(this, props, 'notes')}
          />
          <TextInput
            label={"Gear Slots"}
            value={props.state.gearSlots}
            change={change.bind(this, props, 'gearSlots')}
            type="number"
          />
        </div>
      </div>
      <div className="actionPane">
        {_renderActionButton(props)}
        <ResetButton onClick={_resetClick.bind(this, props)} />
        <Button onClick={_cancelClick.bind(this, props)}>Cancel</Button>
      </div>
    </div>
  );
}


/**
 *
 */
function _renderActionButton(props){
  if(props.state.createSoldier){
    return (<AddButton type="primary" onClick={_addToSoldiers.bind(this, props)}>Create</AddButton>);
  }else if(props.state.editSoldier){
    return (<EditButton type="primary" onClick={_EditSoldiers.bind(this, props)}>Edit</EditButton>);
  }
}


/**
 *
 */
function _addToSoldiers(props){
  if(_validate(props) && props.state.createSoldier){
    const data = _getData(props);
    props.state.createSoldier(data);
  }
}


/**
 *
 */
function _EditSoldiers(props){
  if(_validate(props) && props.state.editSoldier){
    const data = _getData(props);
    props.state.editSoldier(data);
  }
}


/**
 *
 */
function _getData(props){
  let data = {
    "type": props.state.type,
    "name": props.state.name,
    "move": props.state.move,
    "fight": props.state.fight,
    "shoot": props.state.shoot,
    "armor": props.state.armor,
    "will": props.state.will,
    "health": props.state.health,
    "cost": props.state.cost,
    "notes": props.state.notes,
    "gearSlots":  props.state.gearSlots
  };
  return data;
}


/**
 *
 */
function _validate(props){
  let message="";

  if(!props.state.name){
    message = "Name cannot be empty";
  }

  if(message){
    props.updateState(props.stateName, {'errorMessage':message});
    return false;
  }else{
    return true;
  }
}


/**
 *
 */
function _resetClick(props){
  props.resetState(props.stateName, {
    "editSoldier":props.state.editSoldier,
    "createSoldier":props.state.createSoldier,
    "cancelCreate":props.state.cancelCreate
  });
}


/**
 *
 */
function _cancelClick(props){
  if(props.state.cancelCreate){
    props.state.cancelCreate();
  }
}

export default Soldier;
